import { render, staticRenderFns } from "./SectionAncestorsEdit.vue?vue&type=template&id=599573e8&scoped=true&"
import script from "./SectionAncestorsEdit.vue?vue&type=script&lang=js&"
export * from "./SectionAncestorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599573e8",
  null
  
)

export default component.exports